// extracted by mini-css-extract-plugin
module.exports = {"main_title":"Science_main_title__lpH2S","person":"Science_person__1yYif","photo":"Science_photo__1GTsk","text":"Science_text__3h_fV","name":"Science_name__2Rr7B"};